import React from 'react';
import { Link } from '@mui/material';
import { Link as RouterLink } from 'react-router-dom';
import { useModulePermissions } from '../../../hooks/useModulePermissions';
import AccountLabel from './AccountLabel';
import { ledgerPath } from './ledgerPath';

/** An account's label that opens its ledger (plain text for people who can't read the books). */
const AccountLedgerLink: React.FC<React.ComponentProps<typeof AccountLabel> & {
  accountId: string;
  window?: { from?: string | null; to?: string | null };
  onNavigate?: () => void;
}> = ({ accountId, window, onNavigate, ...label }) => {
  const { canRead } = useModulePermissions();
  if (!canRead('finance_journal')) return <AccountLabel {...label} />;
  return (
    <Link component={RouterLink} to={ledgerPath(accountId, window)} underline="hover" color="inherit" onClick={onNavigate}
      title="Open this account's ledger" sx={{ display: 'inline-block', maxWidth: '100%' }}>
      <AccountLabel {...label} />
    </Link>
  );
};

export default AccountLedgerLink;
